var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"logger",staticClass:"logger",domProps:{"innerHTML":_vm._s(_vm.logData)}})
}
var staticRenderFns = []

export { render, staticRenderFns }